// Entry point for the build script in your package.json
// import { Turbo } from "@hotwired/turbo-rails"
// import "@hotwired/turbo-rails"
// import "../sites/pixelearth/controllers/index"
// Turbo.session.drive = false
import * as bootstrap from "bootstrap";

import onLoadShared from "~/shared/on_load";
onLoadShared.run();

import onLoad from "../sites/pixelearth/on_load";
onLoad.run();
